import styled from 'styled-components';
import {RankingButton} from './RankingButton';

export const QuickMenu = () => {
  return (
    <Root>
      <Group>
        <RankingButton />
      </Group>
    </Root>
  );
};

const Root = styled.div`
  display: flex;
  gap: 8px;
`;

const Group = styled.div`
  display: flex;
  box-shadow: 0px 4px 10px 0px #00000026;
  border-radius: 5px;
`;
